import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth/auth.service';
import { DialogService } from 'src/app/services/dialog/dialog.service';
import { TrackerService } from 'src/app/services/data/tracker.service';
import { MapService } from 'src/app/services/map/map.service';
import { environment } from 'src/environments/environment';
import { trackerModalComponent } from '../modals/tracker-modal/tracker-modal.component';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  utenti: Array<any> = [];
  currentUser: string;
  previousUser: string;
  dettaglioUtente: any;
  baseUrlPublic: string;
  spotName = [];
  constructor(
    private authService: AuthService,
    public dialog: MatDialog,
    private dialogService: DialogService,
    private trackerService: TrackerService,
  ) {
    this.baseUrlPublic = environment.baseUrlPublic;
  }

  ngOnInit(): void {
    this.trackerService.getDeviceName(sessionStorage.getItem('region'))
      .subscribe((res: any) => {
        for (let i = 0; i < res.length; i++) {
          this.spotName.push(res[i])
        }
      })
    setInterval(() => {
      this.trackerService.getDeviceName(sessionStorage.getItem('region'))
        .subscribe((res: any) => {
          this.spotName = [];
          for (let i = 0; i < res.length; i++) {
            this.spotName.push(res[i])
          }
        })
    }, 2500);
  }

  openSpot(spotName) {
    this.dialogService.openDialog(spotName);
  }

  logout(){
    this.authService.logout();
  }
}
